import { render, staticRenderFns } from "./LinkedSystem.vue?vue&type=template&id=c226ed92&"
import script from "./LinkedSystem.vue?vue&type=script&lang=js&"
export * from "./LinkedSystem.vue?vue&type=script&lang=js&"
import style0 from "./LinkedSystem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports